import { Link, useLocation } from 'react-router-dom';
import brainAccent from './assets/brain-accent.png'; 

export default function Header() {
  const { pathname } = useLocation();
  const isActive = (path) =>
    pathname === path
      ? 'text-emerald-600 border-b-2 border-emerald-600 pb-1'
      : 'text-gray-700 hover:text-black hover:bg-gray-100 rounded px-2 py-1';

  return (
    <header className="bg-white border-b border-gray-200">
      <nav className="max-w-full md:max-w-6xl mx-auto px-4 sm:px-8 md:px-16 flex justify-between items-center py-4">
        
        {/* Logo and brand name */}
        <Link to="/" className="flex items-center space-x-2 hover:opacity-90">
          <div className="bg-emerald-100 p-1 rounded-full">
            <img
              src={brainAccent}
              alt="Mindzera logo"
              className="w-10 h-10 object-contain"
            />
          </div>
          <span className="text-xl font-semibold text-black">Mindzera</span>
        </Link>

        {/* Nav links */}
        <ul className="flex space-x-6 text-sm sm:text-base">
          <li><Link to="/"            className={isActive('/')}>Home</Link></li>
          <li><Link to="/how"         className={isActive('/how')}>How It Works</Link></li>
          <li><Link to="/your-mindzera-map" className={isActive('/your-mindzera-map')}>Your Mindzera Map</Link></li> {/* Updated link */}
          <li><Link to="/about"       className={isActive('/about')}>About</Link></li>
          <li><Link to="/privacy"     className={isActive('/privacy')}>Privacy</Link></li>
        </ul>
      </nav>
    </header>
  );
}
